import React, {useState} from 'react';
import styles from "./ContactUs.module.scss";
import {Button, Flex, Form, Input} from "antd";
import CustomButton from "../../../../components/UI/CustomButton/CustomButton";
import { ReactComponent as LogoIcon } from '../../../../assets/images/logo/logo.svg'
import { ReactComponent as ArrowIcon } from '../../../../assets/images/global-icons/arrow_ic.svg'
import {useNavigate} from "react-router";
import {useForm} from "antd/es/form/Form";
import {useSelector} from "react-redux";
import {RootState} from "../../../../redux/store";

const ContactUs = () => {
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState('');
  const { isAuth } = useSelector((state: RootState) => state.isAuth);

  const handleClick = () => {
    const to = 'support@krankque.com';
    const subject = 'Request to Add My Company';
    const body = `Hello,\nI couldn't find my company ${companyName} in the list during registration. Could you please assist me with adding it? Let me know what steps I need to take.\nLooking forward to your response.`;

    const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <Flex className={styles.ContactUs__wrapper} justify={"center"} align={"start"}>
      {
        !isAuth &&
          <ArrowIcon
              className={styles.ContactUs__back}
              onClick={() => navigate('../personal/profile')}
          />
      }
      <Flex className={styles.ContactUs} vertical justify={'center'} align={"center"}>
        <Flex className={styles.ContactUs__header} vertical justify={"center"} align={"center"} gap={'32px'}>
          <LogoIcon />
          <h1>Enter your full company name</h1>
          <Flex className={styles.ContactUs__header__subtitle} vertical>
            <p>Once your request is submitted, our team will get back to you as soon as possible</p>
          </Flex>
        </Flex>
        <Flex className={styles.ContactUs__form__wrapper}>
          <Form
            className={styles.ContactUs__form}
            layout="vertical"
          >
            <Form.Item
              name="companyName"
              rules={[
                {
                  required: true,
                  message: 'Company name is required',
                },
              ]}
            >
              <Input
                placeholder="Your Company Name"
                className={styles.ContactUs__form__input}
                onChange={(e) => setCompanyName(e.target.value)}
              />
            </Form.Item>

            <Form.Item>
              <Flex gap={'12px'} vertical align={"center"} className={styles.ContactUs__form__button}>
                <CustomButton text={' Contact us'} disable={!companyName} onClick={() => handleClick()}/>
              </Flex>
            </Form.Item>
          </Form>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ContactUs;